export enum DiscountType {
    NonDiscountItem = 1,
    ServicesOnlyDiscount = 2,
    ProductsOnlyDiscount = 3,
    EntireOrderDiscount = 4,
    SalesSubcategoryDiscount = 5,
    SalesItemDiscount = 6
}
